export const DEFAULT_CROP_SHAPE = 'round';
// Drop the floor to allow extreme zoom-outs for wide/tall images
export const MIN_ZOOM = 0.2;
export const MAX_ZOOM = 3;
export const SLIDER_STEP = 0.1;
export const ACCEPT_FILE_TYPES = 'image/*';
export const DELETE_IMAGE_TEXT = 'Delete image';
